import { serviceUrl } from '../config/net.config'
import request from '@/utils/request'

export function addArchiveQueryAppointment(data) {
    return request({
        url: serviceUrl+'/api/archiveQuery/addArchiveQueryAppointment',
        head: 'application/json;charset=UTF-8',
        method: 'post',
        data,
        token:sessionStorage.getItem('xzztcToken')
    })
}

export function findArchiveQueryAppointment(params) {
    return request({
        url: serviceUrl+'/api/archiveQuery/findArchiveQueryAppointment?id='+params,
        head: 'application/json;charset=UTF-8',
        method: 'get',
        token:sessionStorage.getItem('xzztcToken')
    })
}